import React, { useContext, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { organizationList } from "../../_slice/organizationSlice";
import AppContext from "../../context/AppContext";

function OrganizationTabs() {
  const { setLoader } = useContext(AppContext);

  // React Router hooks for navigation and location state
  const navigate = useNavigate();
  const location = useLocation();

  // Redux hooks for dispatching actions and selecting state
  const dispatch = useDispatch();
  const organizationStatus = useSelector(
    (state) => state?.organization?.status
  );
  const organizationData = useSelector(
    (state) => state?.organization?.organizationData?.organisation
  );

  // Destructure relevant state from the location object
  const { campus, orgId, orglocation, assembly, zone, course } =
    location.state || {};

  // Current URL path for highlighting active tab
  const currentPath = location.pathname;

  // Fetch organization data on initial load if the status is 'idle'
  useEffect(() => {
    if (organizationStatus === "idle") {
      dispatch(organizationList({ setLoader, navigate }));
    }
  }, [organizationStatus, dispatch, setLoader, navigate]);

  // Handle tab clicks with conditional state adjustments based on the target path
  const handleTabClick = useCallback(
    (path, state, isDisabled) => {
      if (!isDisabled) {
        let newState = { orgId: state?.orgId };

        // Adjust state based on the target path to clear nested state properties
        switch (path) {
          case "/organization/campus":
            newState.campus = {};
            newState.orglocation = {};
            break;
          case "/organization/locations":
            newState.campus = {
              campId: state?.campus?.campId,
              campName: state?.campus?.campName,
            };
            newState.orglocation = {};
            break;
          // case '/organization/assemblyPoint':
          //   newState.campus = { campId: state?.campus?.campId, campName: state?.campus?.campName };
          //   newState.orglocation = { locationId: state?.orglocation?.locationId, locationName: state?.orglocation?.locationName };
          //   newState.assembly = {};
          //   break;
          // case '/organization/zones':
          //   newState.campus = { campId: state?.campus?.campId, campName: state?.campus?.campName };
          //   newState.orglocation = { locationId: state?.orglocation?.locationId, locationName: state?.orglocation?.locationName };
          //   newState.assembly = { assemblyId: state?.assembly?.assemblyId, assemblyName: state?.assembly?.assemblyName };
          //   newState.zone = {};
          //   break;

          // New Code
          // case '/organization/zones':
          //   newState.campus = { campId: state?.campus?.campId, campName: state?.campus?.campName };
          //   newState.orglocation = { locationId: state?.orglocation?.locationId, locationName: state?.orglocation?.locationName };
          //   newState.zone = {};
          //   break;
          // case '/organization/assemblyPoint':
          //   newState.campus = { campId: state?.campus?.campId, campName: state?.campus?.campName };
          //   newState.orglocation = { locationId: state?.orglocation?.locationId, locationName: state?.orglocation?.locationName };
          //   newState.zone = { zoneId: state?.zone?.zoneId, zoneName: state?.zone?.zoneName };
          //   newState.assembly = {};
          //   break;

          case "/organization/courses":
            newState.campus = {
              campId: state?.campus?.campId,
              campName: state?.campus?.campName,
            };
            newState.orglocation = {
              locationId: state?.orglocation?.locationId,
              locationName: state?.orglocation?.locationName,
            };
            newState.course = {};
            break;
          case "/organization/courseCompletions":
            newState = { ...state };
            break;
          default:
            newState = {};
            break;
        }

        // Navigate to the new path with the updated state
        navigate(path, { state: newState });
      }
    },
    [navigate]
  );

  // Define the tabs with properties including path, state, and disabled status
  const tabs = [
    {
      id: 1,
      name: "Organization",
      value: organizationData?.name || "",
      path: "/organization",
      state: { campus, orgId, orglocation, assembly, zone, course },
      isDisabled: false,
    },
    {
      id: 2,
      name: "Campus",
      value: campus?.campName || "",
      path: "/organization/campus",
      state: { campus, orgId, orglocation, assembly, zone, course },
      isDisabled: !orgId,
    },
    {
      id: 3,
      name: "Location/Equipment",
      value: orglocation?.locationName || "",
      path: "/organization/locations",
      state: { campus, orgId, orglocation, assembly, zone, course },
      isDisabled: !campus?.campId,
    },
    // {
    //   id: 4,
    //   name: 'Zones',
    //   value: zone?.zoneName || '',
    //   path: '/organization/zones',
    //   state: { campus, orgId, orglocation, assembly, zone },
    //   isDisabled: !orglocation?.locationId
    // },
    // {
    //   id: 5,
    //   name: 'Assembly Points',
    //   value: assembly?.assemblyName || '',
    //   path: '/organization/assemblyPoint',
    //   state: { campus, orgId, orglocation, assembly, zone },
    //   isDisabled: !assembly?.assemblyId
    // },
    {
      id: 6,
      name: "Quests",
      value: course?.starting_marker || "",
      path: "/organization/courses",
      state: { campus, orgId, orglocation, assembly, zone, course },
      isDisabled: !orglocation?.locationId,
    },
    {
      id: 7,
      name: "Quest Completions",
      value: "",
      path: "/organization/courseCompletions",
      state: { campus, orgId, orglocation, assembly, zone, course },
      isDisabled: !orglocation?.locationId,
    },
  ];

  return (
    <ul className="tab_listing">
      {tabs.map(({ id, name, value, path, state, isDisabled }) => (
        <li
          key={id}
          className={`tab_listing_inner ${currentPath === path ? "activeTab" : ""
            } ${value ? "tabheight" : ""} ${isDisabled ? "disabled" : ""}`}
          onClick={() => handleTabClick(path, state, isDisabled)}
        >
          <p className="tab_listing_inner_heading">{name}</p>
          <p className="tab_listing_inner_text">{value}</p>
        </li>
      ))}
    </ul>
  );
}

export default OrganizationTabs;